import Swiper from "swiper";
import { Autoplay, Pagination, A11y } from 'swiper/modules';

const defaultSpeed = 500;
const defaultDelay = 5000;

const selectors = {
  rotatorContainer: ".swiper-wrapper",
  paginationContainer: ".swiper-pagination"
}

const attributes = {
  speed: "data-speed",
  delay: "data-delay"
}

class RotatorContainer {
  private el: HTMLElement;
  private rotatorContainer: HTMLElement;
  private rotatorSpeed: number;
  private rotatorDelay: number;
  private swiper: Swiper;
  private paginationContainer: HTMLElement;

  constructor(el: HTMLElement) {
    this.el = el;
    this.rotatorContainer = this.el.querySelector(selectors.rotatorContainer);
    this.paginationContainer = this.el.querySelector(selectors.paginationContainer);

    this.rotatorSpeed = parseInt(this.rotatorContainer?.getAttribute(attributes.speed) ?? "") || defaultSpeed;
    this.rotatorDelay = parseInt(this.rotatorContainer?.getAttribute(attributes.delay) ?? "") || defaultDelay;
  }

  public init() {
    if (this.rotatorContainer && this.paginationContainer) {
      this.initSwiper();
    }
  }

  private initSwiper = () => {
    this.swiper = new Swiper(this.el, {
      loop: true,
      allowTouchMove: false,
      modules: [Pagination, Autoplay, A11y],
      speed: this.rotatorSpeed,
      autoplay: {
        delay: this.rotatorDelay,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: this.paginationContainer,
        type: 'bullets',
        clickable: true,
      },
    });
  }
}

const components = {
  "rotator-container": RotatorContainer
};

export function initComponents(root = document) {
  Object.entries(components).forEach(([name, Component]) => {
    root.querySelectorAll<HTMLElement>(`[data-component="${name}"]`).forEach(el => {
      new Component(el).init();
    });
  });
}

if (document.readyState !== "loading") {
  initComponents();
} else {
  document.addEventListener("DOMContentLoaded", () => initComponents());
}